import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import qs from "query-string";
import { useLocation } from "react-router-dom";
export var useLoggedOutExperience = function useLoggedOutExperience() {
  var _qs$parse, _location$search;
  var location = useLocation();
  var isLoggedOutUserExperience = !!((_qs$parse = qs.parse((_location$search = location === null || location === void 0 ? void 0 : location.search) !== null && _location$search !== void 0 ? _location$search : "")) !== null && _qs$parse !== void 0 && _qs$parse.loggedOut);
  return {
    isLoggedOutUserExperience: isLoggedOutUserExperience
  };
};